import styled, { keyframes } from "styled-components"
import { latencyComp } from "../../../constants"

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to { 
    opacity: 1;
  }
`

export const GameRulesWrapper = styled.div`
  position: absolute;
  /* 
    These sizes are not as arbitrary as they look,
    as they are just small enough to keep this component
    hidden behind its quizkit overlay counterpart.
  */
  right: 12%;
  left: 11%;
  bottom: 9%;
  font-size: 0.95vw;
  display: flex;
  opacity: 0;
  justify-content: center;
  animation: ${fadeIn} 0.7s forwards;
  animation-delay: ${latencyComp}s;
`